import track from 'react-tracking';
import Modal from '@/components/Modal';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  name: string;
}

const DeleteScreenerModal = ({ onClose, onConfirm, name }: Props) => {
  return (
    <Modal
      title="Delete Screener"
      onSecondaryClick={onClose}
      onPrimaryClick={onConfirm}
      secondaryLabel="Cancel"
    >
      <p>
        Once deleted the <strong>{name}</strong> view cannot be recovered.
      </p>
    </Modal>
  );
};

export default track({
  type: 'track',
  subject: 'DeleteScreenerModal',
})(DeleteScreenerModal);
